import { IconButton, Typography, Stack } from "@mui/material";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import PreviewIcon from "@mui/icons-material/Preview";
import { numberFormat } from "../../helpers/numberFormat";
import { toEnglishDate, toSpanishDate } from "../../helpers/dateFormat";

export const columnsAdmin = (t, onDeleteClick, onEditClick, onViewClick) => {
  return [
    {
      field: "status",
      headerName: t("opportunities.status"),
      minWidth: 120,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <Typography color="primary" variant="body2">
            {row?.status === "Activo"
              ? t("opportunities.statusOpen")
              : t("opportunities.statusClosed")}
          </Typography>
        );
      },
    },
    {
      field: "startup",
      headerName: t("opportunities.startup"),
      minWidth: 200,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "dateOpportunity",
      headerName: t("opportunities.dateOpportunity"),
      minWidth: 150,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <Typography color="primary" variant="body2">
            {toSpanishDate(row.dateOpportunity)}
          </Typography>
        );
      },
    },
    {
      field: "reservationDeadline",
      headerName: t("opportunities.reservationDeadline"),
      minWidth: 170,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => (
        <Typography color="primary" variant="body2">
          {toSpanishDate(row.reservationDeadline)}
        </Typography>
      ),
    },
    {
      field: "amount",
      headerName: t("opportunities.amount"),
      minWidth: 180,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Typography color="primary" variant="body2">
            {numberFormat(params.row.amount)}
          </Typography>
        );
      },
    },
    {
      field: "investmentType",
      headerName: t("opportunities.investmentType"),
      minWidth: 180,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <Typography color="primary" variant="body2">
            {row?.investmentType === "Ampliación Capital"
              ? t("opportunities.investmentTypeCapitalIncrease")
              : t("opportunities.investmentTypeEquityLoan")}
          </Typography>
        );
      },
    },
    {
      field: "roundNumber",
      headerName: t("opportunities.roundNumber"),
      minWidth: 130,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "urlVideo",
      headerName: t("opportunities.doc"),
      minWidth: 130,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Stack direction="row" gap={0}>
            <a href={params.row.urlVideo} target="_blank" rel="noreferrer">
              {t("link.link")}
            </a>
          </Stack>
        );
      },
    },
    {
      field: "url",
      headerName: t("opportunities.url"),
      minWidth: 130,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Stack direction="row" gap={0}>
            <a href={params.row.url} target="_blank" rel="noreferrer">
              {t("link.link")}
            </a>
          </Stack>
        );
      },
    },
    {
      field: "vehicle",
      headerName: t("opportunities.vehicle"),
      minWidth: 240,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "action",
      headerName: t("partnerlist.columnActions"),
      maxWidth: 130,
      align: "center",
      headerAlign: "center",
      flex: 0,
      sortable: false,
      renderCell: (params) => {
        return (
          <Stack direction="row" gap={0}>
            <IconButton color="secondary" onClick={() => onViewClick(params)}>
              <PreviewIcon />
            </IconButton>

            <IconButton color="secondary" onClick={() => onEditClick(params)}>
              <EditRoundedIcon />
            </IconButton>

            <IconButton color="secondary" onClick={() => onDeleteClick(params)}>
              <DeleteOutlineRoundedIcon />
            </IconButton>
          </Stack>
        );
      },
    },
  ];
};

export const columnInvestor = (t, onReserveClick) => {
  return [
    {
      field: "myStatus",
      headerName: t("opportunities.status"),
      minWidth: 150,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "startupAlias",
      headerName: t("opportunities.startup"),
      minWidth: 180,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "roundNumber",
      headerName: t("opportunities.roundNumber"),
      minWidth: 130,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "amount",
      headerName: t("opportunities.amount"),
      minWidth: 140,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        const res =
          row.myStatus === "Sin respuesta" || row.myStatus === "Pending answer"
            ? "-"
            : numberFormat(row.amount);
        return (
          <Typography color="primary" variant="body2">
            {res}
          </Typography>
        );
      },
    },
    {
      field: "reservationDeadline",
      headerName: t("opportunities.reservationDeadline"),
      minWidth: 150,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => (
        <Typography color="primary" variant="body2">
          {toSpanishDate(row.reservationDeadline)}
        </Typography>
      ),
    },
    {
      field: "urlVideo",
      headerName: t("opportunities.doc"),
      minWidth: 130,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Stack direction="row" gap={0}>
            <a href={params.row.urlVideo} target="_blank" rel="noreferrer">
              {t("link.link")}
            </a>
          </Stack>
        );
      },
    },
    {
      field: "url",
      headerName: t("opportunities.url"),
      minWidth: 130,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Stack direction="row" gap={0}>
            <a href={params.row.url} target="_blank" rel="noreferrer">
              {t("link.link")}
            </a>
          </Stack>
        );
      },
    },
    {
      field: "action",
      headerName: t("partnerlist.columnActions"),
      minWidth: 150,
      align: "center",
      headerAlign: "center",
      flex: 0,
      sortable: false,
      renderCell: (params) => {
        const date = new Date();
        const options = { day: "2-digit", month: "2-digit", year: "numeric" };
        const actualDate = date.toLocaleDateString("es-ES", options);
        return (
          <Stack direction="row" gap={0}>
            {params.row.reservationDeadline >= toEnglishDate(actualDate) ? (
              <>
                {params.row.myStatus === "Sin respuesta" ||
                params.row.myStatus === "Pending answer" ? (
                  <IconButton
                    color="secondary"
                    onClick={() => onReserveClick(params)}
                  >
                    <Typography color="secondary.main">
                      {t("opportunities.answer")}
                    </Typography>
                  </IconButton>
                ) : (
                  <IconButton
                    color="secondary"
                    onClick={() => onReserveClick(params)}
                  >
                    <Typography color="secondary.main">
                      {t("opportunities.edit")}
                    </Typography>
                  </IconButton>
                )}
              </>
            ) : (
              <Typography color="secondary.main">
                {t("opportunities.close")}
              </Typography>
            )}
          </Stack>
        );
      },
    },
  ];
};

export const columnsPositions = (
  t,
  onDeleteClick,
  onEditClick,
  onViewClick,
  onDivestmentClick
) => {
  return [
    {
      field: "startup",
      headerName: t("opportunities.startup"),
      minWidth: 200,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "amount",
      headerName: t("opportunities.amountInvested"),
      minWidth: 130,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Typography color="primary" variant="body2">
            {numberFormat(params.row.amount)}
          </Typography>
        );
      },
    },
    {
      field: "investmentType",
      headerName: t("opportunities.investmentType"),
      minWidth: 180,
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: ({ row }) =>
        row.investmentType === "Ampliación Capital"
          ? t("opportunities.investmentTypeCapitalIncrease")
          : t("opportunities.investmentTypeEquityLoan"),
    },
    {
      field: "roundNumber",
      headerName: t("opportunities.roundNumber"),
      minWidth: 120,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "urlVideo",
      headerName: t("opportunities.urlVideo"),
      minWidth: 120,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Stack direction="row" gap={0}>
            <a href={params.row.urlVideo} target="_blank" rel="noreferrer">
              {t("link.link")}
            </a>
          </Stack>
        );
      },
    },
    {
      field: "url",
      headerName: t("opportunities.follow"),
      minWidth: 120,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Stack direction="row" gap={0}>
            <a href={params.row.url} target="_blank" rel="noreferrer">
              {t("link.link")}
            </a>
          </Stack>
        );
      },
    },
    {
      field: "vehicle",
      headerName: t("opportunities.vehicle"),
      minWidth: 220,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "action",
      headerName: t("partnerlist.columnActions"),
      minWidth: 200,
      align: "center",
      headerAlign: "center",
      flex: 0,
      sortable: false,
      renderCell: (params) => {
        return (
          <Stack direction="row" gap={0}>
            <IconButton color="secondary" onClick={() => onViewClick(params)}>
              <PreviewIcon />
            </IconButton>
            <IconButton
              color="secondary"
              onClick={() => onDivestmentClick(params)}
            >
              <AttachMoneyIcon />
            </IconButton>

            <IconButton color="secondary" onClick={() => onEditClick(params)}>
              <EditRoundedIcon />
            </IconButton>

            <IconButton color="secondary" onClick={() => onDeleteClick(params)}>
              <DeleteOutlineRoundedIcon />
            </IconButton>
          </Stack>
        );
      },
    },
  ];
};

export const columnsDividends = (t, onDeleteClick) => {
  return [
    {
      field: "startup",
      headerName: t("opportunities.startup"),
      minWidth: 200,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <Typography color="primary" variant="body2">
            {row.startup?.name || "-"}
          </Typography>
        );
      }
    },
    {
      field: "vehicle",
      headerName: t("opportunities.vehicle"),
      minWidth: 200,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => (
        <Typography color="primary" variant="body2">
          {row.vehicle}
        </Typography>
      )
    },
    {
      field: "dividendDate",
      headerName: t("opportunities.dateOpportunity"),
      minWidth: 150,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => (
        <Typography color="primary" variant="body2">
          {toSpanishDate(row.dividendDate)}
        </Typography>
      )
    },
    {
      field: "dividendPerShare",
      headerName: t("opportunities.dividendPerShareHeader"),
      minWidth: 200,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        const val = row.dividendPerShare !== null && row.dividendPerShare !== undefined
          ? numberFormat(row.dividendPerShare)
          : numberFormat(row.totalAmount);
        return (
          <Typography color="primary" variant="body2">
            {val}
          </Typography>
        );
      }
    },
    {
      field: "action",
      headerName: t("partnerlist.columnActions"),
      minWidth: 100,
      align: "center",
      headerAlign: "center",
      flex: 0,
      sortable: false,
      renderCell: (params) => {
        return (
          <Stack direction="row" gap={0}>
            <IconButton color="secondary" onClick={() => onDeleteClick(params)}>
              <DeleteOutlineRoundedIcon />
            </IconButton>
          </Stack>
        );
      }
    }
  ];
};

